module.exports = __webpack_public_path__ + "img/call.903097e6.png";